<template>
    <div>
        <b-badge
            :variant="variant"
        >
            <span class="badge-count">
                {{ count }}
            </span>
        </b-badge>
    </div>
</template>

<script>
export default {
    name: 'EventStatusCount',
    props: {
        count: {
            type: Number,
            'default': 0,
        },

        loading: {
            type: Boolean,
            'default': false,
        },

        warning: {
            type: Boolean,
            'default': false,
        },

        danger: {
            type: Boolean,
            'default': false,
        },
    },

    computed: {
        variant: vm => vm.danger ? 'danger' : (vm.warning ? 'warning' : 'success'),
    },
};
</script>

<style lang="scss" scoped>
    .badge-count {
        display: block;
        min-width: 2em;
        font-size: 1.2em;
        font-weight: 100;
        line-height: 1.5em;
    }
</style>